/* eslint-disable max-classes-per-file */
import { CustomizationMeshImage } from '../../common/libraries/data/viewer/CustomizationMeshImage';
import { CustomizationObject } from '../../common/libraries/modelViewer/Data/CustomizationObject';

class CustomizationOutputFileData {
  public version : number = 1;
  public objects : Array<CustomizationObject> = [];
}

export class CustomizationsOutputFile {

  public data : CustomizationOutputFileData;

  constructor() {
    this.data = new CustomizationOutputFileData();
  }

  addCustomizationImage(meshID : string, customizationID : string, filePath : string) {

    const existingMesh = this.findOrCreateMeshCustomizations(meshID);

    const newCustomization = new CustomizationMeshImage();
    newCustomization.customizationData.file = filePath;

    existingMesh.customizations.push(newCustomization);

    existingMesh.customizations.push({
      customizationID,
      customizationData: { file: filePath },
    });
  }

  getContents() {
    return JSON.stringify(this.data);
  }

  private findOrCreateMeshCustomizations(meshID : string) {
    let existingMesh = this.data.objects.find((mesh) => {
      return mesh.meshID === meshID;
    });

    if (existingMesh === undefined) {
      const newMeshCustomizationInfo = { meshID, customizations: [] };
      this.data.objects.push(newMeshCustomizationInfo);
      existingMesh = newMeshCustomizationInfo;
    }

    return existingMesh;
  }
}
